<template lang="en">
 <router-link :to="path" :class="class"><p>{{name}}</p> <span :class="spanClass()"></span> </router-link>
</template>

<script>
export default {
  name: 'LinkButton',
  methods : {
    spanClass() {
    const classSpan = this.class;
    if(classSpan === "right"){
        return "spanRight";
      } else if(classSpan === "left") {
        return "spanLeft";
      }else if(classSpan === "normal") {
        return "spanNormal";
      }
    }
    
  },
  props: { 
    path: {
      type: String,
    },
    name: {
      type: String,
    },
    class: {
      type: String
    }
  },
 
}
</script>

<style lang="scss" scoped>
  @import './linkButton.scss';
</style>